/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} City_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Start typing city name..." |
*
* @param {City_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const city_search_placeholder = /** @type {((inputs?: City_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<City_Search_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commencez à taper le nom de la ville...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comience a escribir el nombre de la ciudad...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Comece a digitar o nome da cidade...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizia a digitare il nome della città...")
	return /** @type {LocalizedString} */ ("Start typing city name...")
});